import React from 'react';
import { Card } from 'antd';

// Costanti dei colori
const BOX_SHADOW_COLOR = 'rgba(0, 0, 0, 0.15)';

// Stile comune per le Card
const cardStyle = {
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
    borderRadius: "16px",
    marginBottom: "1.5rem"
};

/**
 * SimpleCard - Un componente wrapper per Card di Ant Design con stile predefinito
 * 
 * @param {ReactNode} children - Contenuto da renderizzare all'interno della card
 * @param {string} title - Titolo opzionale da mostrare nell'header della card
 * @param {function} onClick - Funzione opzionale da chiamare quando la card viene cliccata
 * @param {object} style - Stile opzionale da applicare alla card
 * @param {string} className - Classe opzionale da applicare alla card
 * @returns {JSX.Element} - Componente Card con stile unificato
 */
function SimpleCard({ children, title, onClick, style, className, padding = '1rem', borderRadius = 'clamp(0.25rem, 2vw, 0.5rem)' }) {
    return (
        <Card
            title={title}
            onClick={onClick}
            hoverable
            styles={{
                body: {
                    padding: padding
                }
            }}
            style={{
                width: '100%',
                boxShadow: `clamp(0rem, 0.1vw, 0rem) clamp(0.0625rem, 0.5vw, 0.125rem) clamp(0.25rem, 2vw, 0.5rem) ${BOX_SHADOW_COLOR}`,
                cursor: onClick ? 'pointer' : 'default',
                transition: 'transform 0.2s',
                ...cardStyle,
                ...style,
                borderRadius: borderRadius, // Applica il borderRadius dopo cardStyle per dargli priorità
            }}
            className={className}
        >
            {children}
        </Card>
    );
}

export default SimpleCard;